function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.11053 5.51695C1.59337 5.51695 0.352051 4.27564 0.352051 2.75848C0.352051 1.24131 1.59337 0 3.11053 0C4.62769 0 5.86901 1.24131 5.86901 2.75848C5.86901 4.27564 4.62769 5.51695 3.11053 5.51695ZM3.11053 1.31027C2.31747 1.31027 1.66232 1.96542 1.66232 2.75848C1.66232 3.55154 2.31747 4.20668 3.11053 4.20668C3.90359 4.20668 4.55873 3.55154 4.55873 2.75848C4.55873 1.96542 3.90359 1.31027 3.11053 1.31027Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.07587 5.79282C5.8345 5.48249 5.42073 5.44803 5.1104 5.65491C5.1104 5.65491 4.35182 6.2066 3.11051 6.2066C1.86919 6.2066 1.11061 5.65491 1.11061 5.65491C0.800282 5.41354 0.386509 5.48249 0.145142 5.79282C-0.0962247 6.10315 -0.0272648 6.51692 0.283064 6.75829C0.317545 6.79277 1.04165 7.34447 2.24848 7.51687L0.420991 9.37885C0.145143 9.6547 0.145143 10.1029 0.420991 10.3443C0.558915 10.4822 0.731318 10.5512 0.903722 10.5512C1.07613 10.5512 1.24854 10.4822 1.38646 10.3443L3.11051 8.58579L4.83456 10.3443C4.97248 10.4822 5.14488 10.5512 5.31729 10.5512C5.48969 10.5512 5.6621 10.4822 5.80002 10.3443C6.07587 10.0685 6.07587 9.6547 5.80002 9.37885L3.97253 7.51687C5.17937 7.30999 5.90347 6.75829 5.93795 6.75829C6.24828 6.51692 6.28275 6.06867 6.07587 5.79282Z"
});

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.317a9f19.svg";
export { ForwardRef as ReactComponent };